export const zipCodeRegExpressionKey = 'zip_code_reg_expression';

export const zipCodeMaskKey = 'zip_code_mask';

export const twoLetterCountryCodeKey = 'code_2';
